export enum EOpenAIUserRole {
  User = "user",
  Assistant = "assistant"
}
